export enum MouseButton {
	LEFT,
	MIDDLE,
	RIGHT,
}
